export default "__VITE_PUBLIC_ASSET__8763fc7a__"